import { Component } from '@angular/core';

import { RoleService } from '../../services/role.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';
import { CompanyRole } from '../../models/access-management/company-role.model';

@Component({
    selector: 'spv2-company-roles-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class CompanyRolesDropdownComponent extends DropdownBaseComponent<void, CompanyRole> {

  uniqueName = "companyRoles";

  textField = "name";
  valueField = "id";

  enableCache = true;

  dataFunction = () => this.roleService.getCompanyRoles();

  constructor(private roleService: RoleService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
